import React from "react";
import {
  PostHighlightBase,
  Title,
  Subtitle,
  Content,
  Text,
  Image,
  SmallImage,
  Link,
  PostHighlightBackground,
} from "./post-highlight.styled";
import { ContentPostSliceFragment } from "../../types/graphql";
import { linkTo } from "../../utils/contentUtils";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IPostHighlightProps = Slice<
  SharedSliceType,
  ContentPostSliceFragment["primary"]
> & { type: SharedSliceType };

const PostHighlight = ({
  slice,
  context,
}: SliceComponentProps<IPostHighlightProps, IPageContext>) => {
  const primary = slice.primary;
  const postDoc = primary?.content_post?.document;
  const postData = postDoc && "data" in postDoc && postDoc?.data;
  const icon = primary?.content_icon;
  return (
    (postDoc && postData && (
      <PostHighlightBase>
        <PostHighlightBackground>
          <Content>
            <Image image={postData.image?.url || ""} />
            <Text>
              {icon?.url && (
                <SmallImage
                  src={icon.url || ""}
                  alt={icon.alt || "Case Study"}
                />
              )}
              {postData.title && <Title>{postData.title}</Title>}
              {postData.subtitle && <Subtitle>{postData.subtitle}</Subtitle>}
              <Link href={linkTo(postDoc)}>Read the Full Case Study</Link>
            </Text>
          </Content>
        </PostHighlightBackground>
      </PostHighlightBase>
    )) || <></>
  );
};

export default PostHighlight;
